import PlainBadge from "../../components/Badges/PlainBadge";
import { Clock } from "flowbite-react-icons/outline";
import IconWarning from "../../components/Icons/WarningIcon";

export const renderOnTrack = (onTrack: number, lang: string) => {
  if (onTrack === 0) {
    return null;
  }
  let txt: string;
  let color: string;
  if (onTrack === 1) {
    txt = lang === "sv" ? "I fas" : "On track";
    color = "green";
  } else if (onTrack === 2) {
    txt = lang === "sv" ? "Något efter" : "At risk";
    color = "orange";
  } else {
    txt = lang === "sv" ? "Mycket efter" : "Off track";
    color = "red";
  }
  return (
    <PlainBadge text={txt} color={color} size="small"/>
  )
}

export const renderOnTrack2 = (status: "ok"|"behind"|"attention"|"done", lang: string)=> {
  if (status === "done") {
    return <PlainBadge text={lang === "sv" ? "Klar" : "Done"} iconLeft={<Clock className="h-3 w-3 text-neutral-900!" aria-hidden="true"/>} color="green" size="small"/>
  } else if (status === "ok") {
    return <PlainBadge text={lang === "sv" ? "I fas" : "On track"} iconLeft={<Clock className="h-3 w-3 text-neutral-900!" aria-hidden="true"/>} color="green" size="small"/>
  } else {
    let txt: string;
    if (status === "behind") {
      txt = lang === "sv" ? "Ligger efter" : "Behind";
    } else {
      txt = lang === "sv" ? "Följ upp" : "Needs attention";
    }
    return <PlainBadge text={txt} iconLeft={<IconWarning className="size-full" style={{ color: "var(--color-black)" }} aria-hidden="true"/>} color="orange" size="small"/>
  }
}